import getTopics from 'services/apiHelpers/getTopics';
import getStore from 'services/getStore';
import { updateInteractionsOpenAction } from 'actions/updateInteractionsOpenAction';
import getCurrentTopic from 'services/apiHelpers/getCurrentTopic';
import setCurrentTopic from 'services/apiHelpers/setCurrentTopic';
import onScrollEnds from 'services/onScrollEnds';
import { Block } from '@chameleoncreator/creator-app';

const store = getStore();

const navToNextTopic = () => {
  const topics = getTopics();

  const nextTopic =
    topics[topics.findIndex(t => t.id === (getCurrentTopic() as Block).id) + 1];

  if (!nextTopic) return;

  setCurrentTopic(nextTopic.id);

  window.scrollTo(0, 0);
};

const next = (sId, id) => l => {
  if (l !== 'next') {
    console.log('branching');

    window.location.hash = l;
    return;
  }

  // console.log('next');

  // requestAnimationFrame(
  //   () =>
  //     (window.location.hash = Math.random()
  //       .toString(16)
  //       .substr(2, 8))
  // );

  (window as any).locationHistory = null;

  store.dispatch(updateInteractionsOpenAction(id));

  const getNextInteraction = () => {
    // testing this
    const interactions = Array.from(
      document.querySelectorAll('section')
      // '.intersection-observed' ||
    );

    const nextInteraction: any =
      interactions[interactions.findIndex(i => i.id === `i${id}`) + 1];

    // console.log(nextInteraction);

    return nextInteraction;
  };

  requestAnimationFrame(() => {
    const nextInteraction = getNextInteraction();

    // console.log('nextInteraction :', nextInteraction);

    if (nextInteraction) {
      // window.location.href = `#${nextInteraction.id}` || `#i${nextInteraction.id}`;
      nextInteraction.scrollIntoView({
        behavior: 'smooth',
      });

      onScrollEnds(() => {
        nextInteraction.focus();
      });
    } else {
      navToNextTopic();
    }
  });
};

export default next;
